import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const AddedTrackContainer = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 16px;
  padding: 20px 24px 24px 20px;
  min-height: 100px;
  background-color: ${colors.white};
  border-radius: 4px;

  @media ${device.mobileMax} {
    flex-direction: column;
  }
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${device.mobileMax} {
    padding: 0 24px 0 0;
  }
`

export const Headline = styled.div`
  margin-bottom: 24px;
  align-items: center;
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 8px;

  @media ${device.mobileMin} {
    margin-bottom: 16px;
  }
`

export const SpotifyIcon = styled.img`
  margin-right: 8px;
  width: 24px;
  height: 24px;
`

export const Title = styled.h3`
  margin: 0;
  color: ${colors.mainText};
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
`

export const DetailsButton = styled.div`
  position: absolute;
  top: 44.5px;
  right: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9.5px 16px;
  font-size: 14px;
  color: ${colors.greyTextWhiteBg};
  border: 1px solid ${colors.greyStroke};
  border-radius: 100px;
  cursor: pointer;

  @media ${device.mobileMax} {
    display: none;
  }
`

export const DetailsButtonMobile = styled(DetailsButton)`
  display: none;
  margin-top: 16px;
  position: static;
  width: fit-content;
  align-self: center;

  @media ${device.mobileMax} {
    display: flex;
  }
`

export const ChevronIcon = styled.img<{ areDetailsOpened?: boolean }>`
  margin-left: 10px;
  width: 12px;
  height: 12px;
  transform: ${({ areDetailsOpened }) =>
    areDetailsOpened ? `rotate(180deg)` : null};
  transition: 0.15s all ease-in-out;
`

export const DetailsContainer = styled.div<{ areDetailsOpened?: boolean }>`
  position: relative;
  padding-top: ${({ areDetailsOpened }) => (areDetailsOpened ? 32 : 0)}px;
  max-height: ${({ areDetailsOpened }) => (areDetailsOpened ? `1000px` : 0)};
  opacity: ${({ areDetailsOpened }) => (areDetailsOpened ? 1 : 0)};
  overflow: hidden;
  transition: 0.3s all ease-in-out;

  @media ${device.mobileMax} {
    max-height: ${({ areDetailsOpened }) => (areDetailsOpened ? `1000px` : 0)};
  }
`

export const DetailsRow = styled.div<{ divider?: boolean }>`
  margin-top: ${({ divider }) => (divider ? 24 : 0)}px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};

  @media ${device.mobileMax} {
    margin-top: ${({ divider }) => (divider ? 32 : 0)}px;
  }
`

export const RowLabel = styled.span`
  margin-right: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const ChangeDateButton = styled.div`
  position: absolute;
  bottom: 20.5px;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
  cursor: pointer;

  @media ${device.mobileMax} {
    position: static;
    width: fit-content;
    margin: 17.5px auto 0;
  }
`

export const DatepickerMonthContainer = styled.div`
  position: absolute;
  border-radius: 8px;
  box-shadow: 0px 2px 16px rgb(0 0 0 / 5%);
  width: 100%;
  background-color: ${colors.white};
  top: 0;
  right: -110px;
  position: relative;
  width: 100%;
  @media (min-width: 576px) {
    right: -230px;
  }
  .date-picker {
    position: absolute;
    right: 0;
    width: 100%;
    box-shadow: 0px 2px 16px rgb(0 0 0 / 5%);
  }
  .react-datepicker {
    position: absolute;
    top: 20px;
    right: 0px;
    z-index: 100;
    background: ${colors.white};
    border: none;
    border-radius: 8px;
    transform: translateX(-50%);

    @media (min-width: 576px) {
      right: 0px;
      top: 20px;
    }

    &__header {
      background-color: ${colors.white};
      border-color: ${colors.white};
      color: ${colors.mainText};
      font-weight: 400;
      font-size: 14px;
    }

    &__month-container {
      border-radius: 8px;
      box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.05);
    }

    &__current-month {
      color: ${colors.mainText};
    }

    &__navigation {
      &--next {
        border-left-color: ${colors.mainText};
      }
      &--previous {
        border-right-color: ${colors.mainText};
      }
    }
    &__day,
    &__day-name {
      color: ${colors.mainText};
    }
    &__day--selected,
    &__day:hover {
      background-color: ${colors.green};
      color: ${colors.white};
      transition: 1s;
    }
    &__day--disabled {
      color: ${colors.greyTextBlackBg};
    }
  }
`
export const DatePickerContainer = styled.div`
  position: absolute;
  bottom: 20.5px;
  right: 0;

  @media ${device.mobileMax} {
    position: static;
    width: fit-content;
    margin: 17.5px auto 0;
  }
`
